<template>
    <div class="box mb-3">
        <div :class="'row head ' + seriesClass[series]">
            <h3>{{ seriesLabels[series] }}</h3>
        </div>
        <div>
            <div class="container">
                <div class="row mt-3">
                    <div>MÅNADSFÖRBRUKNING <span class="text-muted small">({{ seriesUnits[series] }})</span></div>
                </div>
                <div class="row mt-2">
                    <div class="col">
                        <div class="text-muted small mt-1">{{ lastMonthLabel }}</div>
                        <div class="tight-spacing">
                            <span class="fs-1">{{ lastMonth ? lastMonth : '-' }}</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="text-muted small mt-1">{{ thisMonthLabel }}</div>
                        <div class="tight-spacing">
                            <span class="fs-1">{{ thisMonth ? thisMonth : '-' }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div>SNITT PER DYGN <span class="text-muted small">({{ seriesUnits[series] }})</span></div>
                </div>
                <div class="row mb-4 mt-2">
                    <div class="col-6">
                        <div class="text-muted small">{{ lastMonthLabel }}</div>
                        <div class="tight-spacing">
                            <span class="fs-1">{{ lastMonthAvg ? lastMonthAvg : '-' }}</span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="text-muted small">{{ thisMonthLabel }}</div>
                        <div class="tight-spacing">
                            <span class="fs-1">{{ thisMonthAvg ? thisMonthAvg : '-' }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div>STATISTIK</div>
                </div>
                <div class="row mt-2">
                     <div class="form-check col d-flex justify-content-center align-items-center">
                        <input type="radio" class="form-check-input me-2" :name="series" :id="'daysWeek' + index" checked="true" @change="$emit('period-change', { series, period: 'daysWeek'})">
                        <label class="form-check-label" :for="'daysWeek' + index">vecka</label>
                     </div>
                     <div class="form-check col d-flex justify-content-center align-items-center">
                        <input type="radio" class="form-check-input me-2" :name="series" :id="'monthsYear' + index" @change="$emit('period-change', { series, period: 'monthsYear'})">
                        <label class="form-check-label" :for="'monthsYear' + index">år</label>
                     </div>
                </div>
                <div class="row mt-3">
                    <div class="col-3 text-end">
                        <button class="btn btn-outline-secondary" @click="$emit('previous-period', series)">&lt;</button>
                    </div>
                    <div class="col-6 text-center mt-1">
                        {{ chartPeriodLabel }}
                    </div>
                     <div class="col-3 text-start">
                         <button class="btn btn-outline-secondary" @click="$emit('next-period', series)">&gt;</button>
                     </div>
                </div>
                <div class="row chart">
                    <bar :data="chartData" :options="chartOptions" />
                </div>
            </div>
        </div>  
    </div>
</template>

<script>
import seriesHelpers from '@/helpers/seriesHelpers';
import { Chart as ChartJS, Title, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js'
import { Bar } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale, PointElement, LineElement)

export default {
    components: { Bar },
    props: {
        series: String,
        index: Number,
        thisMonth: String,
        lastMonth: String,
        thisMonthLabel: String,
        lastMonthLabel: String,
        thisMonthAvg: String,
        lastMonthAvg: String,
        chartData: Object,
        chartPeriodLabel: String,
    },
    data() {
        return {
            chartOptions: {
                locale: 'sv-SE',
                maintainAspectRatio: false,
                animation: {
                    duration: 0
                },
                plugins: {
                    legend: {
                        display: false
                    },
                },
            },
            // Dictionaries
            seriesLabels: {
                'cold_water.volume': 'Kallvatten',
                'hot_water.volume': 'Varmvatten',
                'heat.energy': 'Värmeenergi',
                'heat.volume': 'Hetvatten',
                'electricity.energy': 'Elektricitet',
                'hca.count': 'Radiator',
                'cold.energy': 'Kyl-energi',
            },
            seriesUnits: {
                'cold_water.volume': 'm³',
                'hot_water.volume': 'm³',
                'heat.energy': 'kWh',
                'heat.volume': 'm³',
                'electricity.energy': 'kWh',
                'hca.count': '',
                'cold.energy': 'kWh',
            },
            seriesClass: {
                'cold_water.volume': 'cold_water',
                'hot_water.volume': 'hot_water',
                'heat.energy': 'heat',
                'heat.volume': 'heat_volume',
                'electricity.energy': 'electricity',
                'hca.count': 'hca',
                'cold.energy': 'cold',
            },
        }
    },
}
</script>

<style>
.box {
    border-radius: 1em;
    border: 1px solid #ccc;
    box-shadow: 5px 5px 5px #00000030;
    background-color: #fff;
}
.head {
    border-top-right-radius: 1em;
    border-top-left-radius: 1em;
    padding-top: 1rem;
    padding-bottom: .1em;
    text-align: center;
    text-transform: uppercase;
}
.chart {
    height: 240px
}
.cold_water {
    color: #2d93dd;
}
.hot_water {
    color: #d32734;
}
.heat {
    color: #ffaa00;
}
.heat_volume {
    color: #ff6600;
}
.electricity {
    color: #ffee00;
}
.hca {
    color: #cc33ff;
}
.cold {
    color: #2d93dd;
}
.tight-spacing {
    line-height: 1;
}
.bordered {
    border: 1px solid hotpink;
}
</style>